// API用の時刻format変換
export const convertTimeFormatForApi = (time) => {
  return time.replace(":", "");
};
